(() => {
  const selector = "[data-p11-contact]";
  const initialized = new WeakSet();

  const messageContent = {
    general: {
      label: "Message",
      placeholder: "Tell us what you need help with.",
    },
    existing: {
      label: "Order Support Details",
      placeholder: "Describe the issue and what you need help with.",
    },
    billing: {
      label: "Billing / Invoice Details",
      placeholder: "Tell us which charge or invoice you need help with.",
    },
  };

  const selectedInquiry = (root) =>
    root.querySelector("[data-p11-contact-type]:checked")?.dataset.p11ContactType || "general";

  const closeProducts = (products, focusTrigger = false) => {
    if (!products) return;
    const trigger = products.querySelector("[data-p11-contact-products-trigger]");
    const menu = products.querySelector("[data-p11-contact-products-menu]");
    products.classList.remove("is-open");
    trigger?.setAttribute("aria-expanded", "false");
    if (menu) menu.hidden = true;
    if (focusTrigger) trigger?.focus();
  };

  const updateProductSummary = (products) => {
    const summary = products.querySelector("[data-p11-contact-products-summary]");
    const selected = Array.from(products.querySelectorAll("[data-p11-contact-product]:checked"));
    if (!summary) return;

    if (selected.length === 0) {
      summary.textContent = "Select interested products";
      summary.classList.add("is-placeholder");
    } else if (selected.length === 1) {
      summary.textContent = selected[0].dataset.label || selected[0].value;
      summary.classList.remove("is-placeholder");
    } else {
      summary.textContent = `${selected.length} products selected`;
      summary.classList.remove("is-placeholder");
    }
  };

  const updateInquiry = (root) => {
    const inquiry = selectedInquiry(root);
    root.dataset.inquiry = inquiry;

    root.querySelectorAll("[data-p11-contact-only]").forEach((group) => {
      const active = group.dataset.p11ContactOnly === inquiry;
      group.hidden = !active;
      group.querySelectorAll("input, select, textarea, button").forEach((control) => {
        control.disabled = !active;
      });
    });

    const phone = root.querySelector("[data-p11-contact-phone]");
    const phoneRequired = root.querySelector("[data-p11-contact-phone-required]");
    const phoneOptional = root.querySelector("[data-p11-contact-phone-optional]");
    const requiresPhone = inquiry === "general";
    if (phone) {
      phone.required = requiresPhone;
      if (requiresPhone) phone.setAttribute("aria-required", "true");
      else phone.removeAttribute("aria-required");
    }
    if (phoneRequired) phoneRequired.hidden = !requiresPhone;
    if (phoneOptional) phoneOptional.hidden = requiresPhone;

    const orderNumber = root.querySelector("[data-p11-contact-order-number]");
    if (orderNumber) {
      orderNumber.required = inquiry === "existing";
      if (inquiry === "existing") orderNumber.setAttribute("aria-required", "true");
      else orderNumber.removeAttribute("aria-required");
    }

    const copy = messageContent[inquiry] || messageContent.general;
    const messageLabel = root.querySelector("[data-p11-contact-message-label]");
    const message = root.querySelector("[data-p11-contact-message]");
    if (messageLabel) messageLabel.textContent = copy.label;
    if (message) message.placeholder = copy.placeholder;

    root.querySelectorAll("[data-p11-contact-products]").forEach((products) => closeProducts(products));
  };

  const initializeProducts = (products) => {
    products.classList.add("is-enhanced");
    const trigger = products.querySelector("[data-p11-contact-products-trigger]");
    const menu = products.querySelector("[data-p11-contact-products-menu]");
    const checkboxes = Array.from(products.querySelectorAll("[data-p11-contact-product]"));
    if (!trigger || !menu) return;

    trigger.hidden = false;
    menu.hidden = true;
    updateProductSummary(products);

    trigger.addEventListener("click", () => {
      const open = trigger.getAttribute("aria-expanded") !== "true";
      if (open) {
        products.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
        menu.hidden = false;
      } else {
        closeProducts(products);
      }
    });

    products.addEventListener("change", (event) => {
      const changed = event.target.closest("[data-p11-contact-product]");
      if (!changed) return;
      const uncertain = checkboxes.find((checkbox) => checkbox.hasAttribute("data-uncertain"));

      if (changed.checked && changed === uncertain) {
        checkboxes.forEach((checkbox) => {
          if (checkbox !== uncertain) checkbox.checked = false;
        });
      } else if (changed.checked && uncertain) {
        uncertain.checked = false;
      }
      updateProductSummary(products);
    });
  };

  const initialize = (root) => {
    if (!root || initialized.has(root)) return;
    initialized.add(root);
    root.classList.add("is-enhanced");

    root.querySelectorAll("[data-p11-contact-products]").forEach(initializeProducts);
    root.querySelectorAll("[data-p11-contact-type]").forEach((radio) => {
      radio.addEventListener("change", () => updateInquiry(root));
    });
    updateInquiry(root);
  };

  const initializeWithin = (scope) => {
    if (scope.matches?.(selector)) initialize(scope);
    scope.querySelectorAll?.(selector).forEach(initialize);
  };

  document.addEventListener("click", (event) => {
    document.querySelectorAll("[data-p11-contact-products].is-open").forEach((products) => {
      if (!products.contains(event.target)) closeProducts(products);
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const products = document.querySelector("[data-p11-contact-products].is-open");
    if (products) closeProducts(products, true);
  });

  document.addEventListener("shopify:section:load", (event) => initializeWithin(event.target));
  initializeWithin(document);
})();
